import { render } from "./SettingsLanguagesDeleteModal.vue?vue&type=template&id=3962f17e&ts=true"
import script from "./SettingsLanguagesDeleteModal.vue?vue&type=script&lang=ts"
export * from "./SettingsLanguagesDeleteModal.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__